import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import backbtn from "../../../../assets/icons/Group 112.svg";

const CategoryPageHeader = ({ title, onBack, extra }) => {
    const { t } = useTranslation("topBar");

    return (
        <div className="mb-4 flex flex-shrink-0 items-center justify-between">
            <div className="flex items-center gap-2">
                <img
                    src={backbtn}
                    alt={t("goBack")}
                    className="-my-1 h-12 cursor-pointer"
                    onClick={onBack}
                    onKeyUp={(e) => {
                        if (e.key === "Enter") onBack();
                    }}
                    role="button"
                    tabIndex={0}
                />
                <span className="text-[1.2rem] fontbold">{title}</span>
            </div>
            {extra ? <div>{extra}</div> : null}
        </div>
    );
};

CategoryPageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    onBack: PropTypes.func.isRequired,
    extra: PropTypes.node,
};

export default CategoryPageHeader;
